export const dataFoods = [
  {
    id: 1,
    name: "Fruit - Banana",
    itemGroup: 'Fruit'
  },
  {
    id: 2,
    name: "Fruit - Melons",
    itemGroup: 'Fruit'
  },
  {
    id: 3,
    name: "Fruit - Paw Paw",
    itemGroup: 'Fruit'
  },
  {
    id: 4,
    name: "Fruit - Pineapple",
    itemGroup: 'Fruit'
  },
  {
    id: 5,
    name: "Fruit - Apple",
    itemGroup: 'Fruit'
  },
  {
    id: 6,
    name: "Vegetable - Tomato",
    itemGroup: 'Vegetable'
  },
  {
    id: 7,
    name: "Vegetable - Potato",
    itemGroup: 'Vegetable'
  },
  {
    id: 8,
    name: "Vegetable - Avocado",
    itemGroup: 'Vegetable'
  },
  {
    id: 9,
    name: "Meals - Beef",
    itemGroup: 'Meals'
  },
  {
    id: 10,
    name: "Meals - Lamp",
    itemGroup: 'Meals'
  },
  {
    id: 11,
    name: "Meals - Chicken",
    itemGroup: 'Meals'
  },
  {
    id: 12,
    name: "Milk - Cream",
    itemGroup: 'Milk'
  },
]

export const optionsProduct = [
  {
    id: 1,
    name: 'Fruit'
  },
  {
    id: 2,
    name: 'Vegetable'
  },
  {
    id: 3,
    name: 'Meals'
  },
  {
    id: 4,
    name: 'Milk'
  }
]